import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { addPages, removePage } from '../../redux/reducers/navigationReducer/NavigationSlice';
import PageHeader from '../../components/common/pageHeader/PageHeader';
import { NavigationKey } from '../../components/appNavigationBar/AppNavigation.types';
import { TableData } from '../../models/tableData/types';
import TagsProductsTable from '../../components/tags/TagProductsTable/TagProductsTable';
import TagProductsBox from '../../components/tags/TagProductsBox/TagProductsBox';
import { getProductsByTagIdAction } from '../../redux/actions/tagActions';
import { sortExpressionRecord } from '../../components/tags/TagProductsTable/TagProductsTable.consts';

interface Params {
    id: string;
}


const TagsInfoPage: React.FC = () => {
    const [tableData, setTableData] = useState<TableData>({
        curPage: 1,
        pageSize: 10,
        searchString: '',
        sortDirection: 'asc',
        sortExpression: sortExpressionRecord.productName, // default sort by product name
    });
    const [selectedProductIds, setSelectedProductIds] = useState<number[]>([]);

    const dispatch = useAppDispatch();
    const params = useParams() as Params;
    const tagId = Number(params.id);
    const { authReducer } = useAppSelector((state) => state);
    const { tags, productsByTagId } = useAppSelector((state) => state.tagReducer);

    const tagName =
        tags.find((t) => t.id === tagId)?.name ??
        '';
    const totalCount = productsByTagId[tagId]?.products.length ?? 0;
    useEffect(() => {
        if (tagId) {
            dispatch(getProductsByTagIdAction(tagId));
        }
    }, [dispatch, tagId]);

    useEffect(() => {
        dispatch(
            addPages([
                {
                    key: NavigationKey.DASHBOARD,
                    value: `${authReducer.user?.firstName}'s Dashboard`,
                },
                {
                    key: '/tags',
                    value: 'Tags',
                },
                {
                    key: `/tags-info/${params.id}`,
                    value: tagName,
                },
            ]),
        );
        return () => {
            dispatch(removePage());
        };
    }, [tagName]);

    return (
        <>
            <PageHeader title={tagName} />
            <TagProductsBox>
                <TagsProductsTable
                    tagId={tagId}
                    setTableData={setTableData}
                    tableData={tableData}
                    totalCount={totalCount}
                    setSelectedProductIds={setSelectedProductIds}
                    selectedProductIds={selectedProductIds} />
            </TagProductsBox>
        </>
    );
};

export default TagsInfoPage;
